import { useWindowSize } from "@uidotdev/usehooks";
import { useLayoutEffect, useState } from "react";

// See tailwind.config `screens`
const screens = Object.freeze({
  "2xs": 380,
  xs: 480,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  "2xl": 1536,
} as const);

const useContainerSize = (container?: Element | null) => {
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    if (!container) return undefined;

    const resizeObserver = new ResizeObserver((entries) => {
      const entry = entries[0];

      setWidth(entry.contentRect.width);
    });

    resizeObserver.observe(container);

    return () => {
      resizeObserver.disconnect();
    };
  }, [container]);

  return { width };
};

export const useScreenSize = (
  container?: Element | null,
): Record<string, boolean> => {
  const { width: containerWidth } = useContainerSize(container);
  const { width: windowWidth } = useWindowSize();

  const width = container ? containerWidth : windowWidth;

  if (!width) {
    return {};
  }

  return {
    isMax2xs: width < screens["2xs"],
    isMin2xs: width >= screens["2xs"],
    isMaxXs: width < screens.xs,
    isMinXs: width >= screens.xs,
    isMaxSm: width < screens.sm,
    isMinSm: width >= screens.sm,
    isMaxMd: width < screens.md,
    isMinMd: width >= screens.md,
    isMaxLg: width < screens.lg,
    isMinLg: width >= screens.lg,
    isMaxXl: width < screens.xl,
    isMinXl: width >= screens.xl,
    isMax2xl: width < screens["2xl"],
    isMin2xl: width >= screens["2xl"],
  };
};
